import React, { useCallback, useEffect, useRef, useState } from 'react'
import { getGradient } from '../../tutorialsBase'
import { ShareOnHackerNews } from './ShareOnHackerNews'
import { ShareOnLowEndTalk } from './ShareOnLowEndTalk'
import { ShareOnReddit } from './ShareOnReddit'
import { ShareOnTwitter } from './ShareOnTwitter'
import { ShareLink } from './ShareLink'
import { SocialButton } from './SocialButton'
import classNames from 'classnames'
import { useOnClickOutside } from '../../../utils/useOnClickOutside'
import { wrapper, open, shareIcon, buttonsWrapper } from './MobileShareButton.module.scss'

export const MobileShareButton = ({ frontmatter }) => {
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const gradient = getGradient(frontmatter.header_img)

  useEffect(() => {
    const onScroll = () => {
      if (window.pageYOffset > 400) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const onOpen = () => {
    setIsOpen(true)
  }

  const onClose = (event) => {
    event.stopPropagation()
    setIsOpen(false)
  }

  const onClickOutside = useCallback(() => {
    if (isOpen) {
      setIsOpen(false)
    }
  }, [isOpen])

  useOnClickOutside(ref, onClickOutside)

  const wrapperClassName = classNames(
    wrapper,
    isVisible ? 'd-flex' : 'd-none',
    'box-gradient d-lg-none',
    gradient.bigBox,
    { [open]: isOpen }
  )

  return (
    <div
      onClick={onOpen}
      onFocus={onOpen}
      onBlur={() => { setIsOpen(false) }}
      className={wrapperClassName}
      ref={ref}
      role={'button'}
    >
      <span className={shareIcon} onClick={onOpen}>
        <i className='fa fa-share-alt'/>
      </span>
      <div className={buttonsWrapper} role={'menu'}>
        <ShareOnHackerNews frontmatter={ frontmatter } role={'menuitem'} />
        <ShareOnLowEndTalk frontmatter={ frontmatter } role={'menuitem'} />
        <ShareOnReddit frontmatter={ frontmatter } role={'menuitem'} />
        <ShareOnTwitter frontmatter={ frontmatter } role={'menuitem'} />
        <ShareLink role={'menuitem'} />
        <SocialButton onClickCapture={onClose} className={'cursor-pointer'} role={'menuitem'}>
          <i className='fa fa-close' />
        </SocialButton>
      </div>
    </div>
  )
}
